import React from "react";
import { Link } from "react-router-dom";
import { v2Href } from "../publicRoutes";
import "./footerV2.css";

const logo = require("../../assets/images/BDR-logo.png");

const FooterV2 = ({ preview = false }) => {
  return (
    <footer className="bdrv2-footer">
      <div className="bdrv2-container bdrv2-footer-inner">
        <div className="bdrv2-footer-brand">
          <img src={logo} alt="Biggin's Door Refinishing" />
          <p className="bdrv2-footer-tag">
            Family-owned wood door refinishing in San Antonio since 2012.
          </p>
        </div>

        <nav className="bdrv2-footer-col" aria-label="Pages">
          <h4>Explore</h4>
          <Link to={v2Href(preview, "home")}>Home</Link>
          <Link to={v2Href(preview, "ourDoors")}>Our Doors</Link>
          <Link to={v2Href(preview, "quote")}>Request a Quote</Link>
          <Link to={v2Href(preview, "contact")}>Contact</Link>
        </nav>

        <nav className="bdrv2-footer-col" aria-label="Legal">
          <h4>Legal</h4>
          <Link to={v2Href(preview, "privacy")}>Privacy Policy</Link>
          <Link to={v2Href(preview, "terms")}>Terms of Service</Link>
        </nav>

        <div className="bdrv2-footer-col">
          <h4>Get in touch</h4>
          <a href="tel:12105897431">210-589-7431</a>
          <a href="mailto:leanne@bigginsdoorrefinishing.com">
            leanne@bigginsdoorrefinishing.com
          </a>
        </div>
      </div>

      <div className="bdrv2-footer-bar">
        <span>
          &copy; {2026} Biggin&apos;s Door Refinishing. All rights reserved.
        </span>
      </div>
    </footer>
  );
};

export default FooterV2;
